/**
 * Styles for segment filter components.
 * Uses components-v2 design tokens for consistency.
 */

import { StyleSheet } from 'aphrodite';
import { brandSecondary } from '../../../../styles/colors';
import { CssSelectors } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	ifLabel: {
		color: brandSecondary,
		fontWeight: 600,
		fontSize: 13,
		flexShrink: 0,
	},
	primaryFilterContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		flexWrap: 'wrap',
	},
	filterDropdownTrigger: {
		height: 32,
		fontSize: '0.8125rem',
		lineHeight: '1.25rem',
		padding: '6px 10px',
		fontFamily: 'inherit',
	},
	filterDropdownContent: {
		width: 'max-content',
		minWidth: 200,
		maxWidth: 320,
		fontFamily: 'inherit',
	},
	filterDropdownItem: {
		fontSize: '0.8125rem',
		lineHeight: '1.25rem',
		whiteSpace: 'nowrap',
		fontFamily: 'inherit',
	},
	filterSearchField: {
		...CssSelectors.allDescendants(
			{
				width: 160,
			},
			'.autocomplete-search-field-input'
		),
		...CssSelectors.allDescendants(
			{
				flexShrink: 0,
			},
			'.svg-icon'
		),
		...CssSelectors.allDescendants(
			{
				minWidth: 0,
			},
			'input'
		),
	},
	tagPillContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
	},
	defaultText: {
		color: '#4A4A4A',
		fontSize: 13,
	},
	policySelectorContainer: {
		width: '100%',
		maxWidth: 280,
	},
});

// Backwards compatible alias
export const segmentFilterStyles = styleSheet;
